import { lazy, Suspense } from "react";
import { openQuoteModal } from "./quote-modal";
import { Reveal } from "./reveal";
import { LazyMount } from "./lazy-mount";

// The slider only ever renders inside <LazyMount> (never during SSR), so its
// chunk can be fetched on approach instead of shipping with the first load.
const GalleryVideoSlider = lazy(() =>
  import("./gallery-video-slider").then((m) => ({ default: m.GalleryVideoSlider })),
);

/** Home gallery — muted job-clip video slider + before/after photo slider. */

export function HomeGallery() {
  return (
    <section id="gallery" className="bg-[#F4F6F8] pt-10 pb-6 md:pt-20 md:pb-10 scroll-mt-24">
      <div className="mx-auto max-w-[1200px] px-4">
        <div className="text-center mb-6 md:mb-12">
          <p className="text-[#C8102E] font-semibold uppercase tracking-[0.2em] text-sm mb-3">
            Real Results
          </p>
          <h2
            className="text-[#0B3D7A] text-3xl md:text-5xl uppercase leading-tight"
            style={{ fontFamily: "Oswald, sans-serif", fontWeight: 700 }}
          >
            See The Capital Pro Difference
          </h2>
        </div>

        {/* PART 1 — Muted job clips slider */}
        <Reveal className="mb-8 md:mb-10">
          <h3
            className="text-[#0B3D7A] text-2xl md:text-3xl uppercase text-center mb-6"
            style={{ fontFamily: "Oswald, sans-serif", fontWeight: 700 }}
          >
            On The Job
          </h3>
          <LazyMount minHeight={420}>
            <Suspense fallback={<div style={{ minHeight: 420 }} />}>
              <GalleryVideoSlider />
            </Suspense>
          </LazyMount>
        </Reveal>

        <div className="text-center mt-8">
          <button
            type="button"
            onClick={() => openQuoteModal()}
            className="btn-pop btn-shimmer btn-jiggle inline-block bg-[#C8102E] hover:bg-[#a50d25] text-white font-bold uppercase tracking-wide px-8 py-4 rounded-md transition-colors min-h-[44px]"
          >
            Get Your Free Quote
          </button>
        </div>
      </div>
    </section>
  );
}
